export const IndicatorDot = ({color = '#9AE299'}) => (
  <svg
    width="54"
    height="57"
    viewBox="0 0 54 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_311_6186)">
      <circle cx="27" cy="27" r="14" fill="white" />
      <circle cx="27" cy="27" r="10.5" stroke={color} strokeWidth="7" />
    </g>
    <defs>
      <filter
        id="filter0_d_311_6186"
        x="5"
        y="13"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0509804 0 0 0 0 0.0392157 0 0 0 0 0.172549 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_311_6186"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_311_6186"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);